/* eslint-disable react/prop-types */
import { CheckCircleIcon, InformationCircleIcon, NoSymbolIcon } from '@heroicons/react/24/outline';
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from './toast';
import { useToast } from './use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant = 'default', ...props }) {
        return (
          <Toast key={id} {...props} variant={variant}>
            <div className="flex items-center gap-2">
              <div>
                {variant === 'default' ? <CheckCircleIcon className="h-7 w-7" strokeWidth={2} /> : null}
                {variant === 'destructive' ? <NoSymbolIcon className="h-7 w-7" strokeWidth={2} /> : null}
                {variant === 'warning' ? <InformationCircleIcon className="h-7 w-7" strokeWidth={2} /> : null}
              </div>
              <div className="grid gap-0.5">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
